import React from 'react';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
    TextBox,
} from '../../components/Form';


import {
    Title,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffDeliverTimesNew(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formKey, setFormKey] = useState(null);
    const [formTitle, setFormTitle] = useState(null);
    const handlecomp1 = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handlecomp2 = async () => {
        await postData('/api/panel/page/taroff-deliver-times-new/save-data', {
            key: formKey,
            title: formTitle,
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    return (
        <PanelBox>
            <DataForm>
                <Title>ایجاد زمان ارسال</Title>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'کلید یکتا'} value={formKey} onChange={setFormKey} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'عنوان'} value={formTitle} onChange={setFormTitle} />
                    </GridColumn>
                </Grid>
                <LeftComponents>
                    <Button onClick={handlecomp1}>انصراف</Button>
                    <Button onClick={handlecomp2}>ذخیره</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
